export const ATUALIZADO = 'Serviço atualizado'
export const CADASTRADO = 'Serviço adicionado'
export const NAO_ENCONTRADO = 'Não foram encontrados serviços cadastrados'
export const NAO_ENCONTRADO_FILTRO = 'Não há serviços com esse filtro'
